import { ColDef, ICellRendererParams } from 'ag-grid-community';
import {
  createAdministratorNameCol,
  createCustomCol,
  createDateHasAllTimeCol,
  createDateRangeCol,
  createDetailButtonColV2,
  createIdCol,
  createIndexCol,
  createNumberCol,
  createStatusBadgeCol,
  createTypoCol,
  createViewableCol,
} from '@/src/helpers/agColumnHelper';
import { formatter } from '@/src/utils/formatter';
import DonationDto from '@/src/models/DonationDto';
import { UNIT_STRINGS } from '@/src/constants/unit';

export const donationListColumn = (
  onDetailClick: (id: number) => void,
): ColDef[] => [
  createIdCol(),
  createDateRangeCol({
    field: 'startedAt',
    keys: ['startedAt', 'endedAt'],
    size: 'lg',
    flex: 1,
    headerName: '모금 기간',
  }),
  createViewableCol({
    field: 'isExposed',
    headerName: '노출 여부',
  }),
  createStatusBadgeCol({
    field: 'priorityDisplayYn',
    type: 'isApplied',
    size: 'sm',
    headerName: '우선 노출 여부',
  }),
  createStatusBadgeCol({
    field: 'allowDuplicateParticipant',
    type: 'allowDuplicateParticipant',
    size: 'sm',
    headerName: '참여 방법',
  }),
  createTypoCol({
    field: 'title',
    size: 'lg',
    flex: 2,
    headerName: '제목',
  }),
  createNumberCol({
    field: 'credit',
    size: 'md',
    cellRenderer: ({ data }: ICellRendererParams<DonationDto>) => {
      return `${formatter.NUM_COMMA(data?.participantsCredit)}/${formatter.NUM_COMMA(data?.goalCredit)}`;
    },
    headerName: '모금 크레딧/목표 크레딧',
  }),
  createNumberCol({
    field: 'participantsCnt',
    size: 'sm',
    headerName: '참여자 수',
  }),

  createDateHasAllTimeCol({
    field: 'createdAt',
    size: 'md',
    headerName: '등록 일시',
  }),
  createAdministratorNameCol({
    headerName: '등록 관리자',
  }),
  createDetailButtonColV2(onDetailClick),
];

export const donationParticipantListColumn: ColDef[] = [
  createIndexCol(),
  createDateHasAllTimeCol({
    field: 'createdAt',
    size: 'md',
    headerName: '기부 일시',
  }),
  createTypoCol({
    field: 'nick',
    size: 'sm',
    cellRenderer: ({ data }: ICellRendererParams) =>
      data?.customer?.nick || '-',
    headerName: '닉네임',
  }),
  createTypoCol({
    field: 'name',
    size: 'sm',
    cellRenderer: ({ data }: ICellRendererParams) =>
      data?.customer?.name || '-',
    headerName: '이름',
  }),
  createTypoCol({
    field: 'phone',
    size: 'md',
    cellRenderer: ({ data }: ICellRendererParams) =>
      data?.customer?.phone ? formatter.PHONE(data?.customer?.phone) : '-',
    headerName: '핸드폰 번호',
  }),
  createCustomCol({
    field: 'donationCredit',
    size: 'sm',
    cellRenderer: ({ value }: ICellRendererParams) => {
      return `${formatter.NUM_COMMA(value)}`;
    },
    headerName: `크레딧(${UNIT_STRINGS.CREDIT})`,
  }),
  createTypoCol({
    field: 'signupSource',
    size: 'sm',
    cellRenderer: ({ data }: ICellRendererParams) => {
      return data?.signupSource === null ? '에코야얼스' : data?.signupSource;
    },
    headerName: '가입 경로',
  }),
];
